<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <design-settings :slug="slug" :data-user="dataUser" :data-country="dataCountry" :locale="locale"></design-settings>

        <!-- <order-settings :slug="slug"></order-settings> -->

        <!-- overlay -->
        <!-- <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay> -->
        <!-- end overlay -->

    </v-container>
</template>
<script>
export default {
    data() {
        return {
            breadcrumbs: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    href: '/admin/dashboard',
                },
                {
                    text: 'Mis datos',
                    disabled: true,
                    href: '',
                }
            ],
        }
    },
    props: ['slug', 'dataUser', 'dataCountry', 'locale'],
}
</script>
